/**
 * Format numbers: add , to the thousandth place.
 *
 */
export const numberFormatter = (value?: number | string) => {
  return value ? Intl.NumberFormat("en").format(Number(value)) : "";
};
